
// const { generalSetting } = useContext(AppContext);
// import environment from '../utils/environment';
// export function icoPage(){
//     return generalSetting?.system_config?.system_image_favicon ? environment.baseUsmImageUrl + generalSetting?.system_config?.system_image_favicon : "/asset/icon/favicon.ico"
// }

// const var_project = {
//     name: "Hoai Giang shop",
//     title: "Hoài Giang shop - Chuyên may, bán và cho thuê trang phục",
//     description: "Hoài Giang shop chuyên may bán, thiết kế các loại trang phục áo dài, công sở, biểu diễn, hóa trang, dân tộc... chất lượng cho quý khách với giá cả hợp lý.",
//     url_logo: domain + "asset/icon/logo.webp"
// }

import moment from "moment";
import { INewsArticle, IProduct, IImageObject, IWebPage, IBreadcrumbList} from "./interface";
import { constant } from "../../utils/constant";
import { addKeyToImage, getMetaImg } from "../../utils/utils";

function changeFormatDate(strDate:string="", strFormat:string="YY-MM-DD HH:mm:ss"){
  try{ 
    return moment(strDate, strFormat).toISOString();
  }catch(e){
    console.log(e);
    return strDate;
  }
}

export async function generateGSnippet(url:any, webPage:IWebPage = {}, imageObject:IImageObject = {}, breadcrumbList:Array<IBreadcrumbList> = [], newsArticle:INewsArticle = {}, product:IProduct = {}) {
  try{
    let is_home = (url == '/');
    let domain = process.env.SITE_URL;
    url = domain?.slice(0, -1) + url;
    let inLanguage = "vi";
    let author = {
        url: domain +"#profile/hoai-giang",
        name: "Hoài Giang"
    };
    let result:any = {
                    "@context": "https://schema.org",
                    "@graph": [
                        {
                            "@type": [
                                "ClothingStore",
                                "Organization"
                            ],
                            "@id": domain + "#organization",
                            "name": constant.name_page,
                            "url": domain,
                            "logo": {
                                "@type": "ImageObject",
                                "@id": domain + "#logo",
                                "url": constant.url_logo,//"https://hoaigiangshop.net/wp-content/uploads/2019/09/cropped-hgs-fav.png",
                                "contentUrl": constant.url_logo,//"https://hoaigiangshop.net/wp-content/uploads/2019/09/cropped-hgs-fav.png",
                                "caption": constant.name_page,
                                "inLanguage": inLanguage,
                                "width": "160",
                                "height": "35"
                            },
                            "address": constant.address_page,
                            "openingHours": [
                                "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday 09:00-18:00"
                            ],
                            "image": {
                                "@id": domain + "#logo"
                            },
                            "sameAs": [
                                "https://www.facebook.com/hoaigiangshop",
                                "https://www.facebook.com/hoaigiangshop.cn2",
                                "https://www.facebook.com/hoaigiangshop.cn3/",
                                "https://www.tiktok.com/@hoaigiangshop",
                                "https://www.tiktok.com/@thuylinh5929",
                                "https://www.tiktok.com/@hgscn3"
                            ] 
                        },
                        {
                            "@type": "WebSite",
                            "@id": domain + "#website",
                            "url": domain,
                            "name": constant.title_page,
                            "description": constant.description_page,
                            "publisher": {
                                "@id": domain + "#organization"
                            },
                            "inLanguage": inLanguage
                        },
                        {
                            "@type": "Person",
                            "@id": author.url,
                            "name": author.name
                        },
                        
                        // {
                        //     "@type": "CollectionPage",
                        //     "@id": "https://hoaigiangshop.net/ao-vest/vest-nam-han-quoc#webpage",
                        //     "url": "https://hoaigiangshop.net/ao-vest/vest-nam-han-quoc",
                        //     "name": "Bảng giá thuê vest nam HCM, Mẫu vest nam mới 2025- Hoài Giang shop",
                        //     "isPartOf": {
                        //         "@id": "https://hoaigiangshop.net/#website"
                        //     },
                        //     "inLanguage": inLanguage
                        // }
                    ]}
    let item = result["@graph"];
    let _breadcrumbList:Array<IBreadcrumbList> = [
        {
            name: "Trang chủ",
            url: "/"
        }
    ];
    _breadcrumbList.push(...breadcrumbList);
    if(_breadcrumbList && _breadcrumbList.length > 0){
        item.push({
            "@type": "BreadcrumbList",
            "@id": url + "#breadcrumb",
            "itemListElement": _breadcrumbList.map((x:IBreadcrumbList, index:number)=> {
              let url:any = (x.url ? domain?.slice(0, -1) + x.url : "");
                return {
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": x.name,
                    "item": url
                    }
            })
        })
    }
    if(imageObject && imageObject.url_img && typeof imageObject.url_img !== 'undefined'){
        let img = await getMetaImg(imageObject.url_img);
        item.push({
                "@type": "ImageObject",
                //https://bbcosplay.com/furisode-kimono-suzuko-no-aki-vang-chieu-thu-cua-nhanh-tuyet-tung-16894#primaryimage
                "@id": url + "#primaryimage",
                "inLanguage": inLanguage,
                "url": img?.src,//"https://i.bbcosplay.com/16894/kimono-vang-14.jpg"
                "contentUrl": img?.src,
                "width": img?.naturalWidth ? img?.naturalWidth : 0,
                "height": img?.naturalHeight ? img?.naturalHeight : 0,
                "caption": imageObject.caption
            })
    }
    if(webPage){
        item.push({
            "@type": "WebPage",
            "@id": url + "#webpage",
            "url": url,
            "name": webPage.name,
            "description": webPage.description,
            "datePublished": changeFormatDate(webPage.dateCreated),
            "dateModified": changeFormatDate(webPage.dateModified),
            "breadcrumb": {
                "@id": url + "#breadcrumb"
            },
            // "about": {
            //   "@id": domain +"#organization"
            // },
            "isPartOf": {
              "@id": domain +"#website"
            },
            "author": {
                "@id": author.url
            },
            "potentialAction": [
                {
                    "@type": "ReadAction",
                    "target": [
                        url
                    ]
                }
            ],
            "inLanguage": inLanguage
          })

          if(webPage.primaryImageOfPage && typeof webPage.primaryImageOfPage !== 'undefined'){
            let item_WebSite = item.find((x:any) => x["@type"] == "WebPage");
            if(item_WebSite){
              let url_min = addKeyToImage(webPage.primaryImageOfPage, 0, false, false, true, false);
              item_WebSite["primaryImageOfPage"] = {
                "@id": url_min + "#primaryimage"
              }
            }
            
          }
        if(is_home){
            item.push({
                "@type": "Article",
                "headline": webPage.name,
                "keywords": webPage.keyword?.map((x:any)=>x.keyword)?.join(","),
                "datePublished": changeFormatDate(webPage.dateCreated),
                "dateModified": changeFormatDate(webPage.dateModified),
                "author": {
                    "@id": author.url
                },
                "publisher": {
                    "@id": domain + "#organization"
                },
                "description": webPage.description,
                "name": webPage.name,
                "@id": domain +"#richSnippet",
                "isPartOf": {
                  "@id": domain + "#webpage"
                },
                "inLanguage": inLanguage,
                "mainEntityOfPage": {
                  "@id": domain + "#webpage"
                }
              })
          }
    }
    if(newsArticle && newsArticle.headline){
        item.push(
            {
              "@type": "NewsArticle",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": url
              },
              "headline": newsArticle.headline,
              "image": newsArticle.arr_image,
              "description": newsArticle.description,
              "datePublished": changeFormatDate(newsArticle.dateCreated),
              "dateModified": changeFormatDate(newsArticle.dateModified),
              "author": {
                "@type": "Person",
                "name": author.name,
                "url": author.url
              },
              "publisher": {
                "@type": "Organization",
                "name": constant.name_page,
                "logo": {
                  "@type": "ImageObject",
                  "url": constant.url_logo
                }
              }
            })
    }
    if(product && product.name && product.arr_image){
      let is_Rent = (product.priceRent ? true : false);
      let stock = product?.totalAmount ? product?.totalAmount : 0;
      let _arr_img = await Promise.all(product.arr_image.map(async (x:any)=>{
                            let img = await getMetaImg(x);
                            return  {
                                      "@type": "ImageObject",
                                      "url": img?.src,
                                      "width": img?.naturalWidth ? img?.naturalWidth : 0,
                                      "height": img?.naturalHeight ? img?.naturalHeight : 0,
                                    }
                            }));
      item.push({
          "@type": "ItemPage",
          "@id": url + "#webpage",
          "url": url,
          "name": product.name,
          "datePublished": changeFormatDate(product.dateCreated),
          "dateModified": changeFormatDate(product.dateModified),
          "isPartOf": {
            "@id": domain +"#website"
          },
          "primaryImageOfPage": {
            "@id": product?.url_img,
          },
          "inLanguage": inLanguage
        });
          item.push(
            {
              "@type": "Product",
              "name": product.name,
              "description": product.description,
              "category": product.category,
              "mainEntityOfPage": {
                "@id": url + "#webpage"
              },
              "image": _arr_img,
              "@id": url + "#richSnippet"
            })
          
            let item_Prod = item.find((x:any) => x["@type"] == "Product");
            if(item_Prod){
              if(!is_Rent){
                item_Prod["offers"] = {
                  "@type": "Offer",
                  "price": product.price, //number
                  "priceCurrency": "VND",
                  "priceValidUntil": moment().add(1, 'y').format("YYYY-MM-DD"), // "2026-12-31"
                  "availability": "https://schema.org/" + (stock > 0 ? "InStock" : "PreOrder"),//"https://schema.org/InStock",
                  "itemCondition": "https://schema.org/NewCondition",
                  "url": url,//"https://hoaigiangshop.net/san-pham/ao-vest/vest-nam-han-quoc/vest-nam-den-phoi-nut-kieu",
                  "seller": {
                    "@type": "Organization",
                    "@id": domain,
                    "name": constant.name_page,
                    "url": domain,
                    "logo": constant.url_logo
                  }
                }
              }else{
                item_Prod["offers"] = {
                  "@type": "AggregateOffer",
                  "lowPrice": product.priceRent,
                  "highPrice": product.price,
                  "priceCurrency": "VND",
                  "priceValidUntil": moment().add(1, 'y').format("YYYY-MM-DD"), // "2026-12-31"
                  "availability": "https://schema.org/" + (stock > 0 ? "InStock" : "PreOrder"),//"https://schema.org/InStock",
                  "itemCondition": "https://schema.org/NewCondition",
                  "url": url,//"https://hoaigiangshop.net/san-pham/ao-vest/vest-nam-han-quoc/vest-nam-den-phoi-nut-kieu",
                  "seller": {
                    "@type": "Organization",
                    "@id": domain,
                    "name": constant.name_page,
                    "url": domain,
                    "logo": constant.url_logo
                  }
                }
                if(stock > 0){
                  item_Prod["offers"]["offerCount"] = stock;
                }
              }
            }
        
    }
    if(is_home){
        let item_WebSite = item.find((x:any) => x["@type"] == "WebSite");
        if(item_WebSite){
            item_WebSite["potentialAction"] = {
                "@type": "SearchAction",
                "target": domain + "search?s={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        }
        
    }
    return result;
  }catch(e){
    return null;
  }
    
}